export const FooterElementType = Object.freeze({
    ANCHOR: "anchor",
    BUTTON: "button"
});
